import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { RawLanguagesResponse, Language } from 'types/language';

export const languageKeys = { list: ['languages', 'list'] as const };

export function useLanguages() {
  return useQuery({
    queryKey: languageKeys.list,
    queryFn: () => get('getLanguages') as Promise<RawLanguagesResponse>,
    select: (response): { languages: Language[]; defaultLanguageCode?: string } => {
      const languages = response.results ?? [];
      const defaultLang = languages.find((l) => l.isDefault);
      return { languages, defaultLanguageCode: defaultLang?.code };
    },
    staleTime: 5 * 60 * 1000,
  });
}
